"use client";

import { createContext, useContext } from "react";

interface QuickReplyContextValue {
  sendMessage: (text: string) => void;
}

const QuickReplyContext = createContext<QuickReplyContextValue | null>(null);

export const QuickReplyProvider = QuickReplyContext.Provider;

export function useQuickReply() {
  return useContext(QuickReplyContext);
}
